import marked from "marked";
import DOMPurify from "dompurify";

export default {
  methods: {
    parseMarkdown(md) {
      return DOMPurify.sanitize(marked(md));
    },
  },
};
